import { WarenkorbValidationResult } from '@ps20/bff-models';
import {
  compareProductIdsIfExistingAndSpLaufnrNotExists,
  FEVorvertragsnummer,
  getAnzeigenamen,
  getAppEnumBySpartenType,
} from '@ps20-frontend/frontend-models';
import { AngebotsId } from '@ps20-frontend/shop-integration-redux';
import { WarenkorbAngebot } from '../../reducers/produkte.reducer';

export function buildInvalidWarenkorbErrorText(
  invalideWarenkorbAngebote: WarenkorbAngebot[],
): string {
  return invalideWarenkorbAngebote
    .map(angebot => {
      const vertragsnummers: string = angebot.vorvertragsNummern
        ?.map(feNummer => feNummer.vertragsnummer)
        .join(', ');
      return `${getAnzeigenamen(angebot.appId)}${vertragsnummers ? ` (${vertragsnummers})` : ''}`;
    })
    .join(', ');
}

export function getInvalideWarenkorbAngebote(
  warenkorbAngebote: Array<WarenkorbAngebot>,
  invalidWarenkorbProdukte: WarenkorbValidationResult[],
): Array<WarenkorbAngebot> {
  const invalidAngebotsIds: Array<AngebotsId> = invalidWarenkorbProdukte.map(produkt => {
    const angebotsId: AngebotsId = {
      appId: getAppEnumBySpartenType(produkt.spartenType),
    };
    if (produkt.angebotsId == null) {
      angebotsId.angebotsId = undefined;
    } else {
      angebotsId.angebotsId = produkt.angebotsId;
    }
    return angebotsId;
  });

  const invalideWarenkorbAngebote: Array<WarenkorbAngebot> = warenkorbAngebote.filter(angebot =>
    invalidAngebotsIds.some(
      id => id.appId === angebot.appId && id.angebotsId === angebot.angebotsId,
    ),
  );

  const alleAngeboteMitVorvertraegeToRemove: Array<WarenkorbAngebot> =
    findAngeboteByVorvertragsnummern(
      warenkorbAngebote,
      invalideWarenkorbAngebote.reduce(
        (acc, angebot) => acc.concat(angebot.vorvertragsNummern),
        [],
      ),
    );

  const additionalAngeboteToRemove: Array<WarenkorbAngebot> =
    alleAngeboteMitVorvertraegeToRemove.filter(
      angebot =>
        !invalidAngebotsIds.some(
          invalidAngebot =>
            invalidAngebot.angebotsId === angebot.angebotsId &&
            invalidAngebot.appId === angebot.appId,
        ),
    );

  return additionalAngeboteToRemove.concat(invalideWarenkorbAngebote);
}

function findAngeboteByVorvertragsnummern(
  warenkorb: Array<WarenkorbAngebot>,
  vorvertraegsnummern: Array<FEVorvertragsnummer>,
): Array<WarenkorbAngebot> {
  return warenkorb.filter(produktInWarenkorb =>
    produktInWarenkorb.vorvertragsNummern?.some(nummer =>
      vorvertraegsnummern.some(vorvertraegsnummer => {
        if (!vorvertraegsnummer?.spLaufnummer && !nummer.spLaufnummer) {
          return (
            vorvertraegsnummer?.vertragsnummer === nummer.vertragsnummer &&
            compareProductIdsIfExistingAndSpLaufnrNotExists(
              vorvertraegsnummer.produktIds,
              nummer.produktIds,
              vorvertraegsnummer?.spLaufnummer,
              nummer.spLaufnummer,
            )
          );
        }
        return (
          vorvertraegsnummer?.vertragsnummer === nummer.vertragsnummer &&
          vorvertraegsnummer?.spLaufnummer === nummer.spLaufnummer
        );
      }),
    ),
  );
}
